<template>
  <div v-if="issue && issue.id" class="ticket-container container-fluid">
    <div class="row">
      <h3><span class="d-none d-md-inline">{{ $t('common.issue') }} </span>#{{ticketId}}</h3>
      <div v-if="saving" class="top-action" style="top:15px;right:15px;">
        Guardando...
      </div>
      <div v-else-if="!isCustomer" class="top-action">
        <button class="btn btn-info no-radius" style="max-width: 25%;font-size:25px" @click="refreshTicket(issue)">
          ⟳
        </button>
        <div class="dropdown" style="display:inline;">
          <button class="btn btn-success no-radius" data-toggle="dropdown">
            <font-awesome-icon icon="envelope" />
          </button>
          <div class="dropdown-menu">
            <button class="dropdown-item" @click="sendMail('customer')">
              Avisar Cliente Finalizado
            </button>
            <button class="dropdown-item" @click="sendMail('WaitingForCustomer')">
              Avisar Cliente En Espera
            </button>
          </div>
        </div>
        <button class="btn btn-warning no-radius" style="max-width: 25%;" data-toggle="modal" data-target="#products" @click="getComponent()">
          Repuestos
        </button>
        <div class="dropdown" style="display:inline">
          <button v-if="superUser" style="font-size: 19px;font-weight:800;" class="btn btn-danger no-radius dropdown-toggle" data-toggle="dropdown">
            ⋮
          </button>
          <div class="dropdown-menu">
            <button v-if="superUser" class="dropdown-item" data-toggle="modal" data-target="#customer">
              {{ $t('action.change_customer') }}
            </button>
            <button v-if="currentUser && currentUser.roles && currentUser.roles.includes('ROLE_ADMIN')" class="dropdown-item" @click="forceGetAllStatus">
              <!-- {{ $t('action.clone') }} -->
              Forzar estados
            </button>
            <div class="dropdown-divider" />
            <button class="dropdown-item" data-toggle="modal" data-target="#clone">
              {{ $t('action.clone') }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="editMode && priorityArray.length || issue.priority && !isCustomer" class="row first-iteration">
      <label class="col-4 mt-1">{{ $t('issue.priority') }}:</label>
      <div v-if="editMode && superUser" class="col-4">
        <select id="priority" v-model="issue.priority" class="form-control form-select" required name="priority">
          <option v-for="(aPriority, index) in priorityArray" :key="index" :value="aPriority">
            {{ aPriority.name }}
          </option>
        </select>
      </div>
      <div v-else-if="issue.priority" class="col-4">
        <span>{{ issue.priority.name }}</span>
      </div>
      <div v-else class="col-4">
        <span>Sin prioridad.</span>
      </div>
    </div>
    <div class="row first-iteration">
      <div class="col-md-3">
        <label> {{ $t('common.short_type') }}: </label>
        <div v-if="editMode && superUser">
          <select v-if="editMode && superUser" id="issueType" v-model="issue.issueType" class="form-control form-select" @change="typeChanged">
            <option :value="''">
              Smartdrone
            </option>
            <option :value="'Presupuesto'">
              Presupuesto
            </option>
            <option :value="'Sancor'">
              Sancor Seguros
            </option>
            <option :value="'Daferol'">
              Daferol
            </option>
            <option :value="'Termalesuy'">
              Termalesuy
            </option>
            <option :value="'AMV'">
              AMV
            </option>
            <option :value="'Zerisur'">
              Zerisur
            </option>
            <option :value="'PcService'">
              PcService
            </option>
          </select>
        </div>
        <span v-else-if="issue.issueType" class="issueValue">
          {{issue.issueType}}
        </span>
        <span v-else class="issueValue">
          Smartdrone
        </span>
      </div>
      <div v-if="!isCustomer" class="col-md-4">
        <label>{{ $t('issue.assigned_to') }}: </label>
        <div v-if="editMode && superUser">
          <select id="assignedTo" v-model="assignationModel" class="form-control form-select" name="assignedTo">
            <option v-if="!issue.assignedTo" disabled :value="null">
              {{ $t('issue.none_assigned_to') }}
            </option>
            <option v-for="(option, index) in technicians" :key="index" :value="option.id">
              {{ option.username }}
            </option>
          </select>
          <span v-if="msg.assignedTo" class="alert-msg">{{msg.assignedTo}}</span>
        </div>
        <span v-else class="issueValue">
          {{ getTechnicianAssigned }}
        </span>
      </div>
      <div class="col-md-5">
        <label>{{ $t('issue.status') }}: <span v-if="!issue.status2">Nuevo</span></label>
        <div v-if="editMode">
          <!-- <select id="status" v-model="issue.status" class="form-control" required name="status">
            <option v-for="(option, index) in options" :key="index" :disabled="option.disabled" :value="option.value">
              {{ option.name }}
            </option>
          </select> -->
          <select id="status2" v-model="issue.status2" class="form-control form-select" required name="status2">
            <option v-for="(aStatus, index) in statusArray" :key="index" :disabled="aStatus.disabled" :value="aStatus">
              {{ aStatus.name }}
            </option>
          </select>
          <span v-if="msg.status" class="alert-msg">{{msg.status}}</span>
        </div>
        <span v-else-if="!issue.active" class="closed">
          Cerrado
        </span>
        <span v-else class="issueValue">
          {{ translateStatus }}
        </span>
      </div>
    </div>
    <div v-if="!editMode" class="row dates">
      <div class="col-md-3">
        {{ $t('common.date') }}: <span class="issueValue">{{ formatDate(issue.dateCreated) }}</span>
      </div>
      <div v-if="issue.dateModified && !isCustomer" class="col-md-4">
        {{ $t('common.last_update') }}: <span class="issueValue">{{ formatDate(issue.dateModified) }}</span>
      </div>
      <div v-if="issue.dateCompleted" class="col-md-5">
        {{ $t('common.closed') }}: <span class="issueValue">{{ formatDate(issue.dateCompleted) }}</span>
      </div>
    </div>
    <div class="row">
      <h4 class="col-12">
        {{ $t('issue.initial_description') }}:
      </h4>
      <div v-if="editMode && superUser" class="col-12">
        <textarea id="issueDescription" v-model="issue.issueDescription" class="form-control" required name="issueDescription" />
        <span v-if="msg.description" class="alert-msg">{{msg.description}}</span>
      </div>
      <span v-else class="col-12">
        {{issue.issueDescription}}
      </span>
    </div>
    <div v-if="issue.issueType === 'Presupuesto'" class="row">
      <h4 class="col-12">
        {{ $t('issue.estimated') }}:
      </h4>
      <div v-if="editMode" class="col-12">
        <input id="estimateDescription" v-model="issue.estimateDescription" class="form-control" name="estimateDescription">
      </div>
      <span v-else-if="issue.estimateDescription" class="col-12">
        {{issue.estimateDescription}}
      </span>
      <span v-else class="col-12">
        -
      </span>
    </div>
    <div class="row">
      <h4 class="col-12">
        {{ $t('issue.diagnostic') }}:
      </h4>
      <div v-if="editMode" class="col-12">
        <textarea id="issueDiagnostic" v-model="issue.issueDiagnostic" class="form-control" name="issueDiagnostic" />
      </div>
      <span v-else-if="issue.issueDiagnostic" class="col-12">
        {{issue.issueDiagnostic}}
      </span>
      <span v-else class="col-12">
        -
      </span>
    </div>
    <div v-if="!isCustomer" class="row">
      <h4 class="col-12">
        {{ $t('issue.customer_info') }}:
      </h4>
      <div class="col-md-4">
        <label>{{ $t('common.name') }}: </label>
        <div v-if="editMode && megaUser">
          <input id="customerName" v-model="issue.customer.firstName" class="form-control" required name="customerName">
          <span v-if="msg.customerName" class="alert-msg">{{msg.customerName}}</span>
        </div>
        <span v-else class="issueValue">
          {{issue.customer.firstName}}
        </span>
      </div>
      <div class="col-md-3">
        <label>{{ $t('common.phone') }}: </label>
        <div v-if="editMode && megaUser">
          <input id="customerPhone" v-model="issue.customer.phone" class="form-control" required name="customerPhone">
          <span v-if="msg.customerPhone" class="alert-msg">{{msg.customerPhone}}</span>
        </div>
        <span v-else class="issueValue">
          {{issue.customer.phone}}
        </span>
      </div>
      <div class="col-md-5">
        <label>{{ $t('common.mail') }}: </label>
        <div v-if="editMode && megaUser">
          <input id="customerEmail" v-model="issue.customer.email" class="form-control" required name="customerEmail">
          <span v-if="msg.customerEmail" class="alert-msg">{{msg.customerEmail}}</span>
        </div>
        <span v-else class="issueValue">
          {{issue.customer.email}}
        </span>
      </div>
    </div>
    <div v-if="editMode || (issue.documentReferredId && issue.documentReferredId.length) || (issue.documentReferredDate && issue.documentReferredDate.length)" class="row">
      <h4 class="col-12">
        {{ $t('issue.document_info') }}:
      </h4>
      <div class="col-md-6">
        <label>{{ $t('issue.document_number') }}: </label>
        <div v-if="editMode && superUser">
          <input id="documentReferredId" v-model="issue.documentReferredId" class="form-control" required name="documentReferredId" type="text">
        </div>
        <span v-else class="issueValue">
          {{issue.documentReferredId}}
        </span>
      </div>
      <div class="col-md-6">
        <label>{{ $t('common.date') }} documento asociado: </label>
        <div v-if="editMode && superUser">
          <input id="documentReferredDate" v-model="issue.documentReferredDate" class="form-control" required name="documentReferredDate" type="text">
        </div>
        <span v-else class="issueValue">
          {{issue.documentReferredDate}}
        </span>
      </div>
    </div>
    <div class="row">
      <h4 class="col-12">
        {{ $t('issue.device_info') }}:
      </h4>
      <div class="col-md-4">
        <label>{{ $t('issue.device_brand') }}: </label>
        <div v-if="editMode && superUser">
          <input id="deviceBrand" v-model="issue.deviceBrand" class="form-control" required name="deviceBrand" type="text">
          <span v-if="msg.deviceBrand" class="alert-msg">{{msg.deviceBrand}}</span>
        </div>
        <span v-else class="issueValue">
          {{issue.deviceBrand}}
        </span>
      </div>
      <div class="col-md-4">
        <label>SKU: </label>
        <div v-if="editMode && superUser">
          <input id="sku" v-model="issue.sku" class="form-control" name="sku" type="text">
        </div>
        <span v-else class="issueValue">
          {{issue.sku}}
        </span>
      </div>
      <div class="col-md-4">
        <label>{{ $t('issue.device_serial') }}: </label>
        <div v-if="editMode && superUser">
          <input id="serialNo" v-model="issue.serialNo" class="form-control" required name="serialNo" type="text">
          <span v-if="msg.serialNo" class="alert-msg">{{msg.serialNo}}</span>
        </div>
        <span v-else class="issueValue">
          {{issue.serialNo}}
        </span>
      </div>
    </div>
    <div class="row">
      <div v-if="!relatedIssues" class="col-12">
        <span class="badge badge-warning">No existen otros tickets para este.</span>
      </div>
      <div v-else-if="relatedIssues.length" class="col-12">
        <div class="list-group mb-3 related-issues-vuvle">
          <div class="list-group-item justify-content-between align-items-center active">
            Ticket del {{issue.serialNo}}
            <span class="badge badge-secondary badge-pill">{{relatedIssues.length}}</span>
          </div>
          <span v-for="(relatedIssue, index) in relatedIssues" :key="index" class="list-group-item list-group-item-action">
            #{{getTicketId(relatedIssue)}} - {{relatedIssue.customer.firstName}} ({{relatedIssue.customer.phone}}) [{{relatedIssue.status2 ? relatedIssue.status2.name : 'Nuevo' }}] - {{ formatDate(relatedIssue.dateCreated) }}
          </span>
        </div>
      </div>
      <div v-else-if="!isCustomer" class="col-12">
        <button class="btn btn-outline-primary" @click="checkForSerial">
          Revisar Imei
        </button>
      </div>
    </div>
    <hr v-if="!isCustomer">
    <div v-if="!isCustomer" class="row">
      <div>
        <h5 @click="getHistory">
          Historia de este Ticket: <span v-if="!logs.length" class="d-none d-md-inline">(click para ver)</span>
        </h5>
        <ul>
          <li v-for="(log, index) in logs" :key="index">
            <span>Usuario: {{log.username}} </span>
            <div>{{ formatDate(log.date, true) }}</div>
            <!-- eslint-disable-next-line vue/no-v-html -->
            <div v-html="log.description" />
          </li>
        </ul>
      </div>
    </div>
    <div v-if="!isCustomer && issue.log && issue.log.length" class="row">
      <div>
        <h4 class="col-12">
          Bitácora:
        </h4>
        <!-- Is commented as customer wants its employees to use extra field -->
        <!-- <div v-if="editMode" class="col-10">
        <textarea id="log" v-model="issue.log" class="form-control" name="log" />
      </div>
      <div v-if="editMode" class="col-2">
        <button class="btn btn-outline-primary" @click="updateIssue(true)">
          Guardar Bitácora
        </button>
      </div>
      <span v-else class="col-12 issueValue">
        {{issue.log}}
      </span> -->
        <span class="col-12 issueValue">
          {{issue.log}}
        </span>
      </div>
      <!-- <span v-else class="col-12 issueValue" v-html="issue.log" />
        TODO will need to be on the lookup for script and style tags! -->
    </div>
    <hr v-if="!isCustomer">
    <div v-if="!issue.active" class="row action-buttons">
      <div>
        <button v-if="superUser" class="btn btn-outline-primary" @click="createPDFClose()">
          Descarga Baja
        </button>
        <button v-if="currentUser.roles.includes('ROLE_ADMIN')" class="btn btn-outline-danger" @click="reactivateIssue()">
          {{ $t('action.activate') }}
        </button>
      </div>
    </div>
    <div v-else-if="!isCustomer" class="row action-buttons">
      <div v-if="!editMode">
        <button class="btn btn-primary" @click="updateIssue()">
          {{ $t('action.edit') }}
        </button>
        <button v-if="superUser && issue.status === 'RepairedSancor' || issue.status2 && issue.status2.name === 'Reparado Sancor'" class="btn btn-outline-primary" @click="createPDFClose()">
          Descarga Baja
        </button>
        <button v-if="superUser" class="btn btn-outline-primary" @click="createPDF()">
          Descarga Ingreso
        </button>
        <button v-if="isClosable" class="btn btn-danger" data-toggle="modal" data-target="#closeIssue" @click="processProductList()">
          {{ $t('action.close') }}
        </button>
      </div>
      <div v-else-if="saving">
        <b>GUARDANDO!</b> (la demora puede ser por el envío de correo).
      </div>
      <div v-else>
        <span class="btn btn-primary" @click="updateIssue()"> {{ $t('action.save') }}</span>
        <span class="btn btn-secondary whiteish" @click="cancelAction">{{ $t('action.cancel') }}</span>
      </div>
    </div>
    <hr v-if="!isCustomer">
    <extra-field v-if="!isCustomer" ref="extraFieldComponent" :issue="issue" :super-user="superUser" />

    <!-- Closing Confirmation modal -->
    <div v-if="isClosable" id="closeIssue" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="modalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 id="modalLabel" class="modal-title">
              Cerrará el ticket #{{ticketId}}
            </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div v-if="issueProductList.products && issueProductList.products.length">
              <h2> Repuestos del ticket </h2>
              <div v-for="(product, index) in issueProductList.products" :key="index">
                <b>{{product.product.description}}</b> $ {{product.price}}
              </div>
              <hr>
              <div v-if="issueProductList.totalPrice && issueProductList.totalPrice > 0">
                <b>Total a cobrar:</b> $ {{issueProductList.totalPrice}}
              </div>
              <div v-else>
                Revise los repuestos antes de continuar.
              </div>
              <div v-if="issueProductList.totalPrice && issueProductList.totalPrice > 0">
                <input v-model="issueProductList.paymentPrice" type="number" class="form-control mb-2 mt-1" placeholder="Cobrado al cliente (Sólo si es diferente al total.)">
                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <label class="input-group-text" for="paymentMethod">Forma de Pago</label>
                  </div>
                  <select id="paymentMethod" v-model="issueProductList.paymentMethod" class="custom-select">
                    <option value="-1" disabled>
                      Elegir una Forma de Pago
                    </option>
                    <option value="contado">
                      Contado
                    </option>
                    <option value="credito">
                      Crédito
                    </option>
                    <option value="debito">
                      Débito
                    </option>
                    <option value="a cobrar">
                      A Cobrar
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div v-else>
              No tiene repuestos, revise o proceda con costo cero.
            </div>
            <div v-if="issueProductList.products && issueProductList.products.length && issueProductList.paymentMethod === '-1'">
              <span style="color: red;">* Debe seleccionar un método de pago</span>
            </div>
            <p><b>¿Está seguro que desea cerrar el ticket?</b></p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">
              No, Cancelar Acción
            </button>
            <span v-if="notClosable">
              Este tipo de ticket requiere al menos 1 repuesto.
            </span>
            <span v-else-if="issueProductList.products && issueProductList.products.length && issueProductList.paymentMethod === '-1'" />
            <button v-else-if="!issueProductList.products || !issueProductList.products.length || (issueProductList.totalPrice && issueProductList.totalPrice > 0)" type="button" class="btn btn-outline-danger" data-dismiss="modal" @click="closeIssue()">
              Cerrar Ticket
            </button>
            <span v-else>
              Es posible que exista 1 repuesto o más con costo cero o menor, eliminelos antes de continuar.
            </span>
          </div>
        </div>
      </div>
    </div>
    <!-- Products -->
    <div id="products" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="modalLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <product-list ref="productListComponent" :issue="issue" :super-user="superUser" />
      </div>
    </div>
    <!-- Customers modal -->
    <div v-if="superUser" id="customer" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="modalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 id="modalLabel" class="modal-title">
              {{ $t('action.change_customer') }}
            </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <input type="text" class="form-control" placeholder="Busque el cliente aquí." @keyup="getCustomers">
            <ul>
              <li v-for="(customer, index) in customers" :key="index" :class="issue.customer.id===customer.id?'selected':''" @click="selectCustomer(customer)">
                {{customer.firstName}} ({{customer.phone}})
              </li>
            </ul>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">
              {{ $t('action.cancel') }}
            </button>
            <button type="button" class="btn btn-primary" data-dismiss="modal" @click="approveChange()">
              {{ $t('action.apply') }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- Cloning modal -->
    <div v-if="superUser" id="clone" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="modalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 id="modalLabel" class="modal-title">
              {{ $t('action.clone') }} {{ $t('common.issue') }}
            </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="input-group mb-3">
              <div class="input-group-prepend">
                <label class="input-group-text">Clonar cuantas veces</label>
              </div>
              <input v-model="cloneqty" type="number" class="form-control" placeholder="Cuantas veces quiere clonar?">
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">
              {{ $t('action.cancel') }}
            </button>
            <button type="button" class="btn btn-primary" data-dismiss="modal" @click="cloneNow">
              {{ $t('action.clone') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-else>
    <p>{{ $t('issue.empty') }}</p>
  </div>
</template>

<script>
import IssueService from '@/services/issue.service';
import DocumentService from '@/services/document.service';
import StatusService from '@/services/status.service';
import PriorityService from '@/services/priority.service';
import CustomerService from '@/services/customer.service';
import ProductList from '@/views/issues/components/ProductList';
import ExtraField from '@/views/issues/components/ExtraField';
import ProductService from '@/services/product.service';
import LogService from '@/services/log.service';
import { getTicketId, formatDate } from '@/utils/page-utils';

export default {
    name: 'Issue',
    components: { ProductList, ExtraField },
    props: {
        issue: {
            type: Object
        },
        superUser: {
            type: Boolean
        },
        isCustomer: {
            type: Boolean
        },
        technicians: {
            type: Array
        }
    },
    data() {
        return {
            megaUser: this.$store.state.auth.user && this.$store.state.auth.user.roles.includes('ROLE_ADMIN'),
            editMode: false,
            saving: false,
            cloneqty: 1,
            options: [],
            statusArray: [],
            priorityArray: [],
            editionIssue: {},
            logs: [],
            customers: [],
            relatedIssues: [],
            issueProductList: {
                products: [],
                paymentMethod: '-1',
                totalPrice: -1,
            },
            msg: {
                assignedTo: '',
                status: '',
                customerEmail: '',
                customerName: '',
                customerPhone: '',
                description: '',
                deviceBrand: '',
                serialNo: ''
            }
        };
    },
    computed: {
        ticketId() {
            return getTicketId(this.issue);
        },
        currentUser() {
            return this.$store.state.auth.user;
        },
        allStatus() {
            return this.$store.state.issues.status;
        },
        translateStatus() {
            var status = this.issue.status;
            var status2 = this.issue.status2;
            if (!status2) {
                if (status === 'New') {
                    return 'Nuevo';
                } else if (status === 'InProgress') {
                    return 'En Proceso';
                } else if (status === 'EstimateAccepted') {
                    return 'Presupuesto Aceptado';
                } else if (status === 'WaitingForCustomer') {
                    return 'En Espera Cliente';
                } else if (status === 'RequestedReplace') {
                    return 'Solicitud de Cambio';
                } else if (status === 'Repaired') {
                    return 'Reparado Correctamente';
                } else if (status === 'RepairedSancor') {
                    return 'Reparado Sancor';
                } else if (status === 'NotRepaired') {
                    return 'No Reparado';
                }
                return '';
            }
            return status2.name;

        },
        isClosable() {
            return this.superUser && (this.issue.status2 && this.issue.status2.last) || (this.issue.status === 'NotRepaired' || this.issue.status === 'RequestedReplace' || this.issue.status === 'Repaired' || this.issue.status === 'RepairedSancor');
        },
        notClosable() {
            if (this.issue.status === 'NotRepaired' || this.issue.status2 && this.issue.status2.name === 'No Reparado') {
                return false;
            }
            if (this.issue.issueType === 'P' || this.issue.issueType === 'Presupuesto' || this.issue.issueType === 'Sancor') {
                if (!this.issueProductList || !this.issueProductList.products || !this.issueProductList.products.length) {
                    return true;
                }
            }
            return false;
        },
        assignationModel: {
            // getter
            get: function get() {
                return !this.issue.assignedTo ? this.issue.assignedTo : this.issue.assignedTo.id;
            },
            // setter
            set: function set(newValue) {
                this.issue.assignedTo = this.technicians.filter(tech => {
                    return tech.id === newValue;
                })[0];
            }
        },
        getTechnicianAssigned() {
            if (this.issue.assignedTo && this.issue.assignedTo.username) {
                return this.issue.assignedTo.username;
            }
            return 'Sin Asignar';
        }
    },
    created() {
        if (!this.options.length) {
            this.initIssueComponent();
        }
    },
    updated() {
        if (this.$route.name === 'aticket') {
            if (this.alreadyRunId !== this.issue.id) {
                this.initIssueComponent(this.issue);
            }
            this.alreadyRunId = this.issue.id;
        }
    },
    methods: {
    /* eslint-disable no-console */
        initIssueComponent(issueLoadedInfo) {
            this.issueProductList = {
                products: [],
                paymentMethod: '-1',
                totalPrice: -1
            };
            this.logs = [];
            this.msg = {
                assignedTo: '',
                status: '',
                customerEmail: '',
                customerName: '',
                customerPhone: '',
                description: '',
                deviceBrand: '',
                serialNo: ''
            };
            this.relatedIssues = [];
            this.saving = false;
            if (this.editMode) {
                this.editionIssue.class = '';
                this.editMode = false;
                // do not mutate props.
                // this.issue = Object.assign({}, this.editionIssue);
                this.$emit('updateTicket', Object.assign({}, this.editionIssue));
                this.editionIssue = {};
            }

            this.options = [
                {name: 'Nuevo', value: 'New', disabled: true},
                {name: 'En Proceso', value: 'InProgress'},
                {name: 'En Espera Cliente', value: 'WaitingForCustomer'}
            ];
            if (this.superUser) {
                this.options.push({name: 'Presupuesto Aceptado', value: 'EstimateAccepted'});
                this.options.push({name: 'Solicitud de Cambio', value: 'RequestedReplace'});
                this.options.push({name: 'Reparado Correctamente', value: 'Repaired'});
                this.options.push({name: 'Reparado Sancor', value: 'RepairedSancor'});

                this.options.push({name: 'No Reparado', value: 'NotRepaired'});

                // this.options.push({name: 'Cerrado', value: 'Closed'});
            } else {
                this.options.push({name: 'Reparado Correctamente', value: 'Repaired'});
                this.options.push({name: 'No Reparado', value: 'NotRepaired'});
            }
            // this was resolved by calling this from the component itself.
            // if (this.$refs.extraFieldComponent) {
            //     this.$refs.extraFieldComponent.initEFComponent();
            // }
            if (issueLoadedInfo) {
                this.getStatus(issueLoadedInfo);
                this.getPriorities();
            }
        },
        getTicketId,
        checkForSerial() {
            IssueService.getIssuesBySerial(this.issue.serialNo).then(
                response => {
                    this.relatedIssues = response.data.filter(anIssue => anIssue.id !== this.issue.id);
                    if (!this.relatedIssues.length) {
                        this.relatedIssues = null;
                    }
                },
                error => {
                    console.log(error.response && error.response.data ||
              error.message || error.toString());
                });
        },
        formatDate,
        getPriorities() {
            const self = this;
            PriorityService.getPriorities(true).then(
                response => {
                    self.priorityArray = response.data;
                },
                error => {
                    console.log(error.response && error.response.data ||
                  error.message || error.toString());
                }
            );
        },
        // This is required when setted wrongly a type.
        typeChanged() {
            this.getStatus(this.issue);
        },
        getStatus(issueLoadedInfo) {
            const self = this;
            if (!issueLoadedInfo.status2) {
                StatusService.getFirstActiveStatus().then(
                    response => {
                        const notFilterableTypes = ['daferol', 'amv', 'zerisur', 'pcservice'];
                        let filterByStatus = self.issue.issueType.toLowerCase();

                        if (!filterByStatus || notFilterableTypes.some(type => filterByStatus.includes(type))) {
                            filterByStatus = 'garantia';
                        }
                        self.statusArray = response.data;
                        self.statusArray = self.statusArray.filter(status =>
                            status.name.toLowerCase().includes(filterByStatus)
                        );
                    },
                    error => {
                        console.log(error.response && error.response.data ||
                      error.message || error.toString());
                    }
                );
            } else {
                // const myStatus = self.allStatus.find(status => issueLoadedInfo.status2.name === status.name);
                const myStatus = issueLoadedInfo.status2;
                let filteredNextStatus = myStatus.nextStatus;
                self.statusArray = [issueLoadedInfo.status2];

                if (!self.superUser) {
                    filteredNextStatus = myStatus.nextStatus.filter(status => status.writePermissions === 'EMPLOYEES');
                }

                if (issueLoadedInfo.issueType && issueLoadedInfo.issueType.toLowerCase() !== 'sancor') {
                    filteredNextStatus.filter(status => status.triggers).forEach(function eachTriggereable(status) {
                        const triggersStr = '{' + status.triggers + '}';
                        try {
                            const triggerActions = JSON.parse(triggersStr);

                            if (triggerActions.customer === 'sancor') {
                                filteredNextStatus = filteredNextStatus.filter(status2 => status2.id !== status.id);
                            }
                        } catch (e) {
                            console.log(e);
                        }
                    });
                }


                self.statusArray.push.apply(self.statusArray, filteredNextStatus);
            }
        },
        forceGetAllStatus() {
            const self = this;
            if (this.superUser && this.currentUser.roles.includes('ROLE_ADMIN')) {
                this.$store.dispatch('issues/getStatus');
                setTimeout(function waitForStatus() {
                    self.statusArray = self.$store.state.issues.status;
                }, 1000);
                // this.statusArray = this.allStatus;
                // StatusService.getStatus(true).then(
                //     response => {
                //         self.statusArray = response.data;
                //     },
                //     error => {
                //         console.log(error.response && error.response.data ||
                //       error.message || error.toString());
                //     }
                // );
            }
        },
        getUserName(userId) {
            if (this.superUser) {
                LogService.getUserNameById(userId).then(
                    response => {
                        return response.data.username;
                    },
                    error => {
                        console.log(error.response && error.response.data ||
                  error.message || error.toString());
                    });
            }
            // return 'Sólo admin.';
        },
        processProductList() {
            var self = this;
            ProductService.getProductList(this.issue.id).then(
                response => {
                    self.issueProductList.totalPrice = 0;
                    self.issueProductList.products = response.data.productLines;
                    self.issueProductList.id = response.data.id;


                    if (self.issueProductList.products && self.issueProductList.products.length) {
                        self.issueProductList.products.forEach(product => {
                            self.issueProductList.totalPrice += product.price * product.quantity;
                        });
                    }
                },
                error => {
                    console.log(error.response && error.response.data ||
              error.message || error.toString());
                }
            );
        },
        cloneNow() {
            var i = 0;
            var data = {
                issueDescription: this.issue.issueDescription,
                customer: this.issue.customer,
                issueType: this.issue.issueType,
                documentReferredId: this.issue.documentReferredId,
                documentReferredDate: this.issue.documentReferredDate,
                deviceBrand: this.issue.deviceBrand
            };
            if (this.cloneqty > 50) {
                this.cloneqty = 50;
            }
            for (;i < this.cloneqty;i++) {
                IssueService.saveIssue(data)
                    .then(response => {
                        import('@/utils/export-pdf').then(pdf => {
                            pdf.openingCase(response.data);
                        });
                        this.$store.dispatch('issues/addIssue', response.data);
                    },
                    error => {
                        console.log(error.response && error.response.data ||
                            error.message || error.toString());
                    });
            }
        },
        validForm(data) {
            var fail = false;
            if (this.superUser) {
                if (!data.assignedTo) {
                    this.msg['assignedTo'] = 'Asigne el ticket a alguien';
                    fail = true;
                }
                if (!data.customer.firstName || !data.customer.firstName.length) {
                    this.msg['customerName'] = 'Campo requerido.';
                    fail = true;
                }
                if (!data.customer.phone || !data.customer.phone.length) {
                    this.msg['customerPhone'] = 'Campo requerido.';
                    fail = true;
                }
                if (!data.issueDescription || !data.issueDescription.length) {
                    this.msg['description'] = 'Campo requerido.';
                    fail = true;
                }

                if (!data.deviceBrand || !data.deviceBrand.length) {
                    this.msg['deviceBrand'] = 'Campo requerido.';
                    fail = true;
                }
                if (!data.serialNo || !data.serialNo.length) {
                    this.msg['serialNo'] = 'Campo requerido.';
                    fail = true;
                }
            }

            if (data.status === 'New' && !data.status2 || !data.status && !data.status2) {
                this.msg['status'] = 'No puede mantener el estado Nuevo';
                fail = true;
            }

            if (fail) {
                return false;
            }
            // check for customer data...
            if (data.issueType && data.issueType === 'P') {
                data.issueType = 'Presupuesto';
            }

            return true;
        },
        updateIssue(dontValidate) {
            var data;
            const self = this;
            if (!this.editMode) {
                if (!this.statusArray || !this.statusArray.length) {
                    this.getStatus(this.issue);
                }
                if (!this.technicians || !this.technicians.length) {
                    this.$store.dispatch('technicians/getTechnicians');
                    setTimeout(function waitForTechs() {
                        self.technicians = self.$store.state.technicians.technicians;
                    }, 600);
                }

                // deep copy of object, so we could reassign it if edition is canceled.
                this.editionIssue = Object.assign({}, this.issue);

                if (!this.issue.issueType) {
                    this.issue.issueType = '';
                } else
                if (this.issue.issueType && this.issue.issueType.toUpperCase() === 'P') {
                    this.issue.issueType = 'Presupuesto';
                }

                this.editMode = true;
                this.$refs.extraFieldComponent.toggleEdit();
                return;
            }

            this.msg = {
                assignedTo: '',
                status: '',
                customerEmail: '',
                customerName: '',
                customerPhone: '',
                description: '',
                deviceBrand: '',
                serialNo: ''
            };

            data = {
                issueDescription: this.issue.issueDescription,
                issueDiagnostic: this.issue.issueDiagnostic,
                estimateDescription: this.issue.estimateDescription,
                log: this.issue.log,
                documentReferredId: this.issue.documentReferredId,
                documentReferredDate: this.issue.documentReferredDate,
                issueType: this.issue.issueType,
                customer: {
                    phone: this.issue.customer.phone,
                    email: this.issue.customer.email,
                    firstName: this.issue.customer.firstName
                },
                priority: this.issue.priority,
                deviceBrand: this.issue.deviceBrand,
                sku: this.issue.sku,
                serialNo: this.issue.serialNo,
                status: this.issue.status,
                status2: this.issue.status2,
                assignedTo: this.issue.assignedTo
            };

            if (!dontValidate && !this.validForm(data)) {
                return;
            }

            // non validated could only refresh logs.
            if (dontValidate) {
                data = {
                    issueDescription: this.editionIssue.issueDescription,
                    issueDiagnostic: this.editionIssue.issueDiagnostic,
                    estimateDescription: this.editionIssue.estimateDescription,
                    log: this.issue.log,
                    documentReferredId: this.editionIssue.documentReferredId,
                    documentReferredDate: this.editionIssue.documentReferredDate,
                    issueType: this.editionIssue.issueType,
                    customer: {
                        phone: this.editionIssue.customer.phone,
                        email: this.editionIssue.customer.email,
                        firstName: this.editionIssue.customer.firstName
                    },
                    priority: this.issue.priority,
                    deviceBrand: this.editionIssue.deviceBrand,
                    sku: this.editionIssue.sku,
                    serialNo: this.editionIssue.serialNo,
                    status: this.editionIssue.status,
                    status2: this.editionIssue.status2,
                    assignedTo: this.editionIssue.assignedTo
                };
            }

            this.saving = true;
            IssueService.updateIssue(this.issue.id, data).then(
                response => {
                    if (this.editMode) {
                        this.editMode = false;
                        this.$refs.extraFieldComponent.saveExtraFields();
                    }

                    this.checkStatusTrigger(response.data);

                    this.getStatus(response.data);
                    // this.issue = response.data;
                    this.$emit('updateTicket', response.data);
                    this.saving = false;
                },
                error => {
                    console.log(error.response && error.response.data ||
              error.message || error.toString());
                });
        },
        refreshTicket(issue) {
            const self = this;
            IssueService.getData(issue.id).then(
                response => {
                    this.$emit('updateTicket', response.data);
                    this.$emit('refreshData');
                    self.issue = response.data;
                    this.initIssueComponent(self.issue);
                },
                error => {
                    console.log(error.response && error.response.data ||
              error.message || error.toString());
                }
            );
        },
        checkStatusTrigger(issue) {
            var triggerActions;
            var triggersStr;
            if (issue.status2) {
                if (issue.status2.triggers) {
                    triggersStr = '{' + issue.status2.triggers + '}';
                    try {
                        triggerActions = JSON.parse(triggersStr);

                        if (this.editionIssue.status2 && this.editionIssue.status2.id !== issue.status2.id) {
                            this.issue.emailSubject = 'Servicio require su atención #' + this.getTicketId(this.issue);
                            this.issue.emailBody = '<b>Requerimos su atención, por favor comunicarse con nosotros.</b><br><p><b>Equipo: </b> ' + this.issue.deviceBrand + ' ' + this.issue.serialNo + '</p><br>';
                            if (this.issue.estimateDescription && this.issue.estimateDescription.length) {
                                this.issue.emailBody += '<p>Presupuesto: ' + this.issue.estimateDescription + '</p>';
                            }
                            // agregado temporalmente.
                            // this.issue.emailBody += '<p style="color:red;">La empresa permanecerá cerrada toda la semana de carnaval.</p>';
                            if (triggerActions.sendmailCustomer) {
                                if (triggerActions.finishedMail) {
                                    this.issue.emailSubject = 'Servicio Finalizado #' + this.getTicketId(this.issue);
                                    this.issue.emailBody = '<b>Servicio finalizado con éxito</b><br><p><b>Equipo: </b> ' + this.issue.deviceBrand + ' ' + this.issue.serialNo + '</p><p>' + this.issue.issueDiagnostic + '</p><br>';
                                }
                                // this.issue.emailBody += '<p style="color:red;">Semana de carnaval cerrado por licencia anual.</p>';
                                // this.issue.emailBody += '<br><p style="font-weight:bold;">Nos Mudamos!<br>';
                                // this.issue.emailBody += 'Te esperamos en Gral. Flores 2830 esquina Ceibal.</p>';
                                this.issue.emailBody += '<p style="font-weight:bold;">092062626 - 0947826651</p>';
                                IssueService.sendMail(this.issue, 'customer').then(
                                    response => {},
                                    error => {
                                        console.log(error.response && error.response.data ||
                                  error.message || error.toString());
                                    });
                            }
                            if (triggerActions.sendmailAssignee) {
                                IssueService.sendMail(this.issue, 'asignee').then(
                                    response => {},
                                    error => {
                                        console.log(error.response && error.response.data ||
                                  error.message || error.toString());
                                    });
                            }
                        }
                    } catch (e) {
                        console.log(e);
                    }
                }
            }
        },
        getHistory() {
            if (!this.logs.length) {
                LogService.getIssueLogs(this.issue.id).then(
                    response => {
                        this.logs = response.data;
                    },
                    error => {
                        console.log(error.response && error.response.data ||
                  error.message || error.toString());
                    });
            }
        },
        getComponent() {
            this.$refs.productListComponent.initProducListComponent();
        },
        // PDF Creation methods.
        createPDF() {
            import('@/utils/export-pdf').then(pdf => {
                pdf.openingCase(this.issue);
            });
        },
        createPDFClose() {
            import('@/utils/export-pdf').then(pdf => {
                pdf.closingCase(this.issue);
            });
        },
        // Customers actions.
        getCustomers(e) {
            if (e.target.value.length > 3) {
                CustomerService.searchCustomers(e.target.value).then(
                    response => {
                        this.customers = response.data;
                    },
                    error => {
                        console.log(error.response && error.response.data ||
                  error.message || error.toString());
                    });
            }
        },
        selectCustomer(customer) {
            this.issue.customer = customer;
        },
        sendMail(type) {
            if (type === 'WaitingForCustomer') {
                this.issue.emailSubject = 'Servicio require su atención #' + this.getTicketId(this.issue);
                this.issue.emailBody = '<b>Requerimos su atención, por favor comunicarse con nosotros.</b><br><p><b>Equipo: </b> ' + this.issue.deviceBrand + ' ' + this.issue.serialNo + '</p><br>';
                if (this.issue.estimateDescription && this.issue.estimateDescription.length) {
                    this.issue.emailBody += '<p>Presupuesto: ' + this.issue.estimateDescription + '</p>';
                }
                /* eslint-disable-next-line no-param-reassign */
                type = 'customer';
            } else {
                this.issue.emailSubject = 'Servicio Finalizado #' + this.getTicketId(this.issue);
                this.issue.emailBody = '<b>Servicio finalizado con éxito</b><br><p><b>Equipo: </b> ' + this.issue.deviceBrand + ' ' + this.issue.serialNo + '</p><p>' + this.issue.issueDiagnostic + '</p><br>';
            }
            // agregado temporalmente.
            // this.issue.emailBody += '<p style="color:red;">Semana de carnaval cerrado por licencia anual.</p>';
            // this.issue.emailBody += '<br><p style="font-weight:bold;">Nos Mudamos!<br>';
            // this.issue.emailBody += 'Te esperamos en Gral. Flores 2830 esquina Ceibal.</p>';
            this.issue.emailBody += '<p style="font-weight:bold;">092062626 - 0947826651</p>';
            IssueService.sendMail(this.issue, type).then(
                response => {},
                error => {
                    console.log(error.response && error.response.data ||
              error.message || error.toString());
                });

        },
        approveChange() {
            IssueService.changeCustomer(this.issue.id, this.issue.customer.id).then(
                response => {
                    // /changecustomer/{idIssue}/{idCustomer}
                },
                error => {
                    console.log(error.response && error.response.data ||
              error.message || error.toString());
                });
        },
        // Issue cancelation or ending process.
        closeIssue() {
            const self = this;
            IssueService.removeIssue(this.issue.id).then(
                response => {
                    // Before sending PDF we should know the pricing.
                    if (this.issueProductList) {
                        if (!this.issueProductList.paymentPrice || Number(this.issueProductList.paymentPrice) < 1) {
                            this.issueProductList.paymentPrice = this.issueProductList.totalPrice;
                        }
                        // this.issue.pricing = this.issueProductList.paymentPrice;
                        if (!this.issueProductList.issue) {
                            this.issueProductList.issue = this.issue;
                        }
                    }

                    import('@/utils/export-pdf').then(pdf => {
                        pdf.closingCase(this.issue);
                    });
                    // Close the Document.
                    if (this.issueProductList) {
                        this.issueProductList.customer = this.issue.customer;

                        ProductService.closeProductsList(this.issueProductList).then(
                            responseData => {
                                let data = {
                                    description: 'Servicio técnico.',
                                    paymentPrice: self.issueProductList.paymentPrice,
                                    relatedDocument: self.issue.id,
                                    docDate: new Date(),
                                    paymentMethod: self.issueProductList.paymentMethod
                                };
                                DocumentService.saveDocument(data)
                                    .then(newDocResponse => {
                                    },
                                    error => {
                                        console.log(error.response && error.response.data ||
                                            error.message || error.toString());
                                    });
                            },
                            error => {
                                console.log(error.response && error.response.data ||
                          error.message || error.toString());
                            }
                        );
                    }

                    this.issue.active = false;
                    this.$emit('updateTicket', this.issue);
                    this.$emit('refreshData');
                    // this.$router.push('/');
                },
                error => {
                    console.log(error.response && error.response.data ||
              error.message || error.toString());
                }
            );
        },
        // permaKillIssue() {
        //     IssueService.permaKillIssue(this.issue.id).then(
        //         response => {
        //             //this.issue.active = true;
        //             //this.$emit('updateTicket', this.issue);
        //             this.$emit('refreshData');
        //             // this.$router.push('/');
        //         },
        //         error => {
        //             console.log(error.response && error.response.data ||
        //       error.message || error.toString());
        //         }
        //     );
        // },
        reactivateIssue() {
            IssueService.reactivateIssue(this.issue.id).then(
                response => {
                    this.issue.active = true;
                    this.$emit('updateTicket', this.issue);
                    this.$emit('refreshData');
                    // this.$router.push('/');
                },
                error => {
                    console.log(error.response && error.response.data ||
              error.message || error.toString());
                }
            );
        },
        cancelAction() {
            this.editMode = false;
            this.customers = [];
            this.$emit('updateTicket', Object.assign({}, this.editionIssue));
            this.$refs.extraFieldComponent.toggleEdit();
            this.editionIssue = {};
        }
    /* eslint-enable no-console */
    }
};
</script>
<style lang="scss">
.alert-msg {
    color: #F00;
    padding-left: 13px;
    display: block;
    font-size: 12px;
}
.ticket-container {
    padding-bottom: 10px;
    border-radius: 5px;
    border: 1px solid #EEE;
    overflow: hidden;
    span.issueValue {
        color: #777;
    }
    .row h5, .action-buttons {
        margin-left: 10px;
        .btn {
            margin-right: 5px;
        }
    }
    .first-iteration {
        border-top: 1px solid #EEE;
    }
    > .row:first-child {
        background-color: #FAFAFA;
        position: relative;
        h3 {
            margin-bottom: 0;
            padding: 8px;
            background-color: #EEE;
            border-radius: 0 5px 0 0;
        }
        .top-action {
            position: absolute;
            right: 0;
            height: 100%;
            text-align: right;
            padding-right: 0;
            // @media(max-width: 600px) {
            //     width: 100%;
            //     position: relative;
            //     text-align: right;
            // }
        }
        .no-radius {
            border-radius: 0;
            height: 100%;
            color: #FFF;
        }
    }
}
.related-issues-vuvle {
    max-height: 296px;
    overflow-y: overlay;
}
.whiteish {
    color: #FFF;
}
span.closed {
    color: red;
}
.dates {
    font-size: 14px;
    line-height: 1;
}
@media (max-width: 410px) {
    .ticket-container .top-action {
        position: relative !important;
        height: 40px !important;
        padding-left: 0;
        > button {
          width: 34% !important;
          max-width: inherit !important;
        }
        .dropdown button {
          width: 33%;
        }
    }
}
</style>
